import { Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-download-application-dialog',
  standalone: true,
  imports: [],
  templateUrl: './download-application-dialog.component.html'
})
export class DownloadApplicationDialogComponent {
  @ViewChild('dialog', { static: true })
  public dialogRef: ElementRef | undefined;

  public show(): void {
    const dialog: HTMLDialogElement = this.dialogRef?.nativeElement as HTMLDialogElement;
    dialog.showModal();
  }
}
